import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as d } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = d((l, e) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: e,
    ...l,
    image: (r) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3 15a2 2 0 0 1-2-2v-2h2v2h10v-2h2v2a2 2 0 0 1-2 2z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M7 7.586 5.171 5.757 3.757 7.172l3.535 3.535a1 1 0 0 0 1.415 0l3.535-3.535-1.414-1.415L9 7.585V.93H7z",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
));
n.displayName = "DownloadIcon";
export {
  n as DownloadIcon,
  n as default
};
//# sourceMappingURL=index.js.map
